module.exports = __webpack_public_path__ + "static/media/print.ddf2011b.svg";